export default "__VITE_ASSET__j$07hWBG__"